/* Park Mile — animaciones de aparición al hacer scroll */
(function () {
  if (window.__mtReveal) return;
  window.__mtReveal = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var io = null;

  if (!reduce && 'IntersectionObserver' in window) {
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
  }

  function init(root) {
    (root || document).querySelectorAll('[data-mt-reveal]:not(.is-in)').forEach(function (el) {
      if (io) io.observe(el);
      else el.classList.add('is-in');
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
